module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('nav', {
    staticClass: "navbar navbar-default navbar-fixed-top"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "navbar-header"
  }, [_vm._m(0), _vm._v(" "), _c('a', {
    staticClass: "navbar-brand",
    attrs: {
      "href": "#/"
    }
  }, [_c('span', {
    staticClass: "first"
  }, [_vm._v(_vm._s(_vm.$lang.messages.n_i_ashmarin))]), _c('span', {
    staticClass: "second"
  }, [_vm._v(" * ")]), _c('span', {
    staticClass: "third"
  }, [_vm._v(_vm._s(_vm.$lang.messages.chuvash_dictionary))])])]), _vm._v(" "), _c('div', {
    staticClass: "collapse navbar-collapse",
    attrs: {
      "id": "menu-block"
    }
  }, [_c('ul', {
    staticClass: "nav navbar-nav navbar-right"
  }, [_c('li', {
    staticClass: "dropdown"
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "#",
      "data-toggle": "dropdown",
      "role": "button",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_vm._v(_vm._s(_vm.$lang.getLang()))]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [(_vm.$lang.getLang() != 'cv') ? _c('li', {
    on: {
      "click": function($event) {
        _vm.toggleLang('cv')
      }
    }
  }, [_c('a', [_vm._v("cv")])]) : _vm._e(), _vm._v(" "), (_vm.$lang.getLang() != 'ru') ? _c('li', {
    on: {
      "click": function($event) {
        _vm.toggleLang('ru')
      }
    }
  }, [_c('a', [_vm._v("ru")])]) : _vm._e(), _vm._v(" "), (_vm.$lang.getLang() != 'eo') ? _c('li', {
    on: {
      "click": function($event) {
        _vm.toggleLang('eo')
      }
    }
  }, [_c('a', [_vm._v("eo")])]) : _vm._e()])]), _vm._v(" "), _c('li', {
    staticClass: "dropdown"
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "#",
      "data-toggle": "dropdown",
      "role": "button",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_vm._v(_vm._s(_vm.$lang.messages.menu))]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/about"
    }
  }, [_vm._v(_vm._s(_vm.$lang.messages.about))])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/helpus"
    }
  }, [_vm._v(_vm._s(_vm.$lang.messages.for_helpers))])], 1)])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [(_vm.search) ? _c('div', {
    staticClass: "input-group",
    attrs: {
      "id": "search"
    }
  }, [_c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-warning btn-lg",
    attrs: {
      "id": "erase-btn",
      "type": "button"
    },
    on: {
      "click": _vm.eraseTerm
    }
  }, [_c('span', {
    staticClass: "fa fa-eraser",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), _c('input', {
    staticClass: "form-control input-lg",
    attrs: {
      "id": "search-field",
      "type": "text",
      "name": "term",
      "placeholder": _vm.$lang.messages.search_word
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.searchTerm($event)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-info btn-lg",
    attrs: {
      "id": "search-btn",
      "type": "button"
    },
    on: {
      "click": _vm.searchTerm
    }
  }, [_c('span', {
    staticClass: "fa fa-search",
    attrs: {
      "aria-hidden": "true"
    }
  })])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4",
    attrs: {
      "id": "sidebar-btn"
    }
  }, [(_vm.lastterms.length > 0) ? _c('div', {
    staticClass: "dropdown"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-xs dropdown-toggle btn-history",
    attrs: {
      "type": "button",
      "id": "dropdownMenu1",
      "data-toggle": "dropdown",
      "aria-haspopup": "true",
      "aria-expanded": "true"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.$lang.messages.history) + "\n                        "), _c('span', {
    staticClass: "caret"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu",
    attrs: {
      "aria-labelledby": "dropdownMenu1"
    }
  }, _vm._l((_vm.lastterms), function(lastterm) {
    return _c('li', [_c('a', {
      attrs: {
        "href": '#/search/' + lastterm
      }
    }, [_vm._v(_vm._s(lastterm))])])
  }))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 button-block text-center",
    attrs: {
      "id": "buttons"
    }
  }, _vm._l((_vm.buttons), function(button) {
    return (_vm.buttons) ? _c('button', {
      staticClass: "btn btn-default btn-xs btn-chuv",
      attrs: {
        "type": "button"
      },
      on: {
        "click": _vm.pressButton
      }
    }, [_vm._v(_vm._s(button))]) : _vm._e()
  })), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 wcounter text-right",
    attrs: {
      "id": "wcounter"
    }
  }, [_c('span', {
    staticClass: "third-part"
  }, [_vm._v(_vm._s(_vm.$lang.messages.articles_on_site) + ": "), (_vm.counter) ? _c('label', {
    staticClass: "label label-default"
  }, [_vm._v(_vm._s(_vm.counter.count))]) : _vm._e()])])]), _vm._v(" "), _c('router-view')], 1), _vm._v(" "), _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('p', {
    staticClass: "text-muted"
  }, [_vm._v("© " + _vm._s(_vm.$lang.messages.haval_org) + ", 2017")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "navbar-toggle collapsed",
    attrs: {
      "type": "button",
      "data-toggle": "collapse",
      "data-target": "#menu-block",
      "aria-expanded": "false"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Toggle navigation")]), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5091d933"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 31
// module chunks = 0